import MedicalCodingAssistant from "./components/MedicalCodingAssistant";

function App() {
  return <MedicalCodingAssistant />;
}

export default App;
